import React from "react";
import styled from "styled-components";

const Container = styled.div`
    background: #ffffff;
    max-width: 474px;
    float: right;
    padding: 20px;
    @media screen and (min-width: 650px) {
        padding: 20px;
    }

    @media screen and (min-width: 800px) {
        width: 100%;
    }
    
    
    @media(max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
    
`;

export default Container;
 